const style = {
  popup: {
    position: "absolute",
    top: "348px",
    left: "583px",
    transform: "translate(-50%, -50%)",
    width: 755,
    backgroundColor: "#FFFFFF",
    borderRadius: "10px",
    boxShadow: 24,
    padding: "30px",
  },
  typography: {
    color: "#8C8C8C",
    fontSize: "20px",
  },
  inputStyle: {
    height: 91,
    minWidth: "330",
    maxWidth: "400",
    // border: "1px solid #707070",
    borderRadius: "5px",
  },
  mediumItem: {
    flex: "1 1 28%",
    paddingLeft: "10px",
  },
  radioButtons: {
    display: "flex",
    gap: 10,
    justifyContent: "space-between",
    maxWidth: "40%",
  },
  boolInputContainer: {
    display: "flex",
    alignItems: "center",
    flex: 2,
  },
  gridContainerStyle: {
    marginTop: 8,
  },
  gridStyle: {
    marginTop: 12,
  },
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridTemplateRows: "1fr",
    gridRowGap: "1.5rem",
    gridColumnGap: "1.5rem",
  },
};

export default style;
